module.exports = __webpack_public_path__ + "media/images/home/main/programma-3575676f854e9afb93e731da2c304579.png";